export default __webpack_public_path__ + "static/media/PrimaryCart.d232f110.svg";